import { storyblokEditable } from "@storyblok/react/rsc";

import { ListItem } from "@/components/layout/ListItem";
import type { ListItemIconName } from "@/components/icons";

import type { AssetStoryblok } from "@/component-types-sb";

// Inline type definition until Storyblok types are regenerated
export type EventInfoItemStoryblok = {
  icon: ListItemIconName;
  custom_icon?: AssetStoryblok;
  text: string;
  _uid: string;
  component: "event_info_item";
  [k: string]: any;
};

type EventInfoItemProps = {
  blok: EventInfoItemStoryblok;
};

const EventInfoItem = ({ blok }: EventInfoItemProps) => {
  return (
    <div {...storyblokEditable(blok)}>
      <ListItem icon={blok.icon} customIconUrl={blok.custom_icon?.filename}>{blok.text}</ListItem>
    </div>
  );
};

export default EventInfoItem;
